import React from 'react'
import formattedDate from "../../utils/formattedDate";
import {
  Card,
  CardHeader,
  Col,
  Row,
  CardBody,
  Button
} from "shards-react";

export default function UserInvoiceTable({invoices, docs, handleDeleteInvoice, selectedUser, loading }) {

  return (
    <>
      <Row>
        <Col>
          <Card small className="mb-4 ">
            <CardHeader className="border-bottom">
              <h6 className="m-0">Invoice Mangement</h6>
            </CardHeader>
            <CardBody className="p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                      Invoice ID
                    </th>
                    <th scope="col" className="border-0">
                      Date
                    </th>
                    <th scope="col" className="border-0">
                      Actions
                    </th>
                  </tr>
                </thead>
                {docs && selectedUser && invoices  && selectedUser.invoices.length > 0 ? (
                  <>
                    <tbody  >
                      {invoices.length > 0 && invoices.map((invoice, index) => (
                        <tr key={invoice.invoice_id}>
                          <td>{index + 1}</td>
                          <td>{invoice.invoice_id}</td>
                          <td>{invoice.invoice_date ? formattedDate(invoice.invoice_date.seconds) : 'loading...'}</td>
                          <td><Button disabled={ loading } onClick={() => handleDeleteInvoice(invoice.invoice_id)} theme="danger">Delete</Button></td>
                        </tr>

                      ))}
                    </tbody>
                  </>
                 ) :
                  (<tbody>
                    <tr>
                      <td>No invoices found</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                  )}
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}
